import * as React from "react";

export const useWindow = () => {
  const openNewTab = React.useCallback((route: string) => {
    let url = window.location.pathname.replace(window.location.hash, "");
    if (window.location.hash) {
      url += "/#";
    }
    if (!route.startsWith("/")) {
      url += "/";
    }
    url += route;

    window.open(url);
  }, []);

  return {
    openNewTab,
  };
};
